var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"#","title":"Valider ce point"},on:{"click":function($event){return _vm.solveItem()}}},[_c('i',{staticClass:"far fa-fw fa-square text-secondary"})])
}
var staticRenderFns = []

export { render, staticRenderFns }